var map = {
	"./de_DE.json": 1080,
	"./en_AU.json": 1081,
	"./en_CA.json": 1082,
	"./en_GB.json": 1083,
	"./es_AR.json": 1084,
	"./es_ES.json": 1085,
	"./es_MX.json": 1086,
	"./fr_CA.json": 1087,
	"./fr_FR.json": 1088,
	"./it_IT.json": 1089,
	"./nl_NL.json": 1090,
	"./pt_BR.json": 1091,
	"./pt_PT.json": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;